"use client";

import { SDUIComponentRenderer } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/__internal__/SDUIComponentRenderer/SDUIComponentRenderer";
import { SDUISectionInstanceRendererProps } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/__internal__/types";
import { useAnimatedRotation } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/SectionRenderers/RotatingSection/useAnimatedRotation";
import { IComponent } from "@faire/web-api--source/indigofair/data/IComponent";
import { cn } from "@faire/web/tools/cn";
import React from "react";

// eslint-disable-next-line import/no-unassigned-import
import "./styles/SDUIRotatingSectionRenderer.tw.css";

export const SDUIRotatingSectionComponentRenderer: React.FC<
  SDUISectionInstanceRendererProps
> = ({ section, componentRenderers, sectionLoggingData, loadTimingRef }) => {
  const { components, delay: rotationDelayMs } = section.rotating_section ?? {};

  const {
    isAnimationInView,
    currentIndex,
    hasCurrentBannerBeenViewed,
    containerRef,
    resumeScroll,
    pauseScroll,
  } = useAnimatedRotation(components, rotationDelayMs);

  if (!components || !components[currentIndex]) {
    return null;
  }

  return (
    <div
      className="col-start-1 row-start-1"
      onMouseEnter={pauseScroll}
      onMouseLeave={resumeScroll}
      ref={containerRef}
    >
      <div
        className={cn(
          "flex h-full items-center",
          isAnimationInView ? "animated-in-container" : "animated-out-container"
        )}
      >
        <SDUIComponentRenderer
          isPrimaryContent
          component={components[currentIndex] ?? IComponent.build({})}
          componentRenderers={componentRenderers}
          sectionLoggingParams={sectionLoggingData}
          loadTimingRef={loadTimingRef}
          disableViewEvent={hasCurrentBannerBeenViewed}
        />
      </div>
    </div>
  );
};
